<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item >首页</el-breadcrumb-item>
          <el-breadcrumb-item>淘客</el-breadcrumb-item>
          <el-breadcrumb-item>商品查询</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true">
          <el-form-item>
            <el-input  placeholder="关键词" v-model="queryParam.name" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" v-on:click="Search" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="items" style="width: 100%">
          <el-table-column  prop="Pid"  label="Pid" width="200px"></el-table-column>
          <el-table-column  prop="Name" label="姓名"> </el-table-column>
          <el-table-column  prop="Number"  label="会员号"></el-table-column>   
          <el-table-column  prop="ImageUrl" label="图标" width="80" align="center">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.ImageUrl"
                placement="right"
                trigger="hover"
              >
                <div>
                  <img
                    :src="scope.row.ImageUrl"
                    width="400"
                    
                  >
                </div>  
                <img
                  slot="reference"
                  :src="scope.row.ImageUrl"
                  width="20"
                  height="20"
                >
              </el-popover> 
              <p v-else>
                --
              </p>
            </template>         
          </el-table-column>         
          <el-table-column  prop="CreateTime" label="创建时间"></el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section> 
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { parseTime } from '@/utils/date'
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam:{
          name: ' ',
          sort: 'id desc',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/pdd/PidList',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.items
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
	      return  parseTime(cellValue, '{y}-{m}-{d}')
      },    
      handleSizeChange(val) {
        this.queryParam.pagesize =  val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>